import { getLocalData, setLocalData } from "@pf126/api-maker/src/StorageServices"

const _store = {
    state: {
        accessToken: getLocalData('accessToken', ''),
        refreshToken: getLocalData('refreshToken', ''),
        user: getLocalData('user', {}),
        roles: getLocalData('roles', []),
    },
    subscribers: []
}

const _broadcast = () => {
    setTimeout(() => {
        _store.subscribers.forEach(subscriber => {
            subscriber(_store.state)
        })
    }, 0)
}

export const notifyUpdate = _broadcast

export const subscribe = subscriber => {
    if (typeof subscriber !== 'function') return
    if (_store.subscribers.indexOf(subscriber) !== -1) return

    _store.subscribers = [].concat(_store.subscribers, subscriber)
}

export const unsubscribe = subscriber => {
    _store.subscribers = _store.subscribers.filter(sub => sub !== subscriber)
}

export const isAuthenticated = () => {
    const { state } = _store

    return !!state.accessToken
}

export const setUserData = user => {
    const updatedUser = user

    _store.state = {
        ..._store.state,
        user: updatedUser
    }

    setLocalData('user', updatedUser)
    _broadcast()
}

export const setRoles = roles => {
    _store.state = {
        ..._store.state,
        roles,
    }

    setLocalData('roles', roles)
}

export const setDepartment = department => {
    _store.state = {
        ..._store.state,
        department,
    }

    setLocalData('department', department)
}

export const setTimeExp = timeExp => {
    _store.state = {
        ..._store.state,
        timeExp,
    }

    setLocalData('timeExp', timeExp)
}

export const getUserData = () => getLocalData('user') || _store.state.user || {}
export const getRoles = () => getLocalData('roles') || _store.state.roles || []

export const setAccessToken = accessToken => {
    _store.state = {
        ..._store.state,
        accessToken,
    }

    setLocalData('accessToken', accessToken)
}

export const setRefreshToken = refreshToken => {
    _store.state = {
        ..._store.state,
        refreshToken,
    }

    setLocalData('refreshToken', refreshToken)
}

export const getAccessToken = () => getLocalData('accessToken') || _store.state.accessToken || ''

export const getRefreshToken = () => getLocalData('refreshToken') || _store.state.refreshToken || ''

export const logoutUser = (message = '') => {

    setAccessToken('')
    setRefreshToken('')
    setUserData({})
    _broadcast()

    return true
}
